export enum ReportTypes {
    Billing = 'BILLING',
    Payroll = 'PAYROLL',
    Utilization = 'UTILIZATION',
    Bench = 'BENCH_NOTES',
}
